/**
 * @author lifei & gll
 * 模块说明：xxx
 */

import { Service } from '@/tools'
export class StoreWarehouseService <T extends TStock.StoreWarehouse> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.StoreWarehouse}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  
            
  /**
   * 功能：编辑店铺仓
   */
  update = (data: T['ApiUpdate']['req']): Promise<T['ApiUpdate']['res']> => this.post2('v1/ApiUpdate', data)
            
  /**
   * 功能：分页查询店铺仓列表
   */
  pageList = (data: T['ApiPageList']['req']): Promise<T['ApiPageList']['res']> => this.post2('v1/ApiPageList', data)
            
  /**
   * 功能：店铺仓下拉列表
   */
  list = (data: T['ApiList']['req']): Promise<T['ApiList']['res']> => this.post2('v1/ApiList', data)
            
  /**
   * 功能：查看店铺仓详情
   */
  detail = (data: T['ApiDetail']['req']): Promise<T['ApiDetail']['res']> => this.post2('v1/ApiDetail', data)
            
  /**
   * 功能：删除店铺仓
   */
  delete = (data: T['ApiDelete']['req']): Promise<T['ApiDelete']['res']> => this.post2('v1/ApiDelete', data)
            
  /**
   * 功能：新增店铺仓
   */
  add = (data: T['ApiAdd']['req']): Promise<T['ApiAdd']['res']> => this.post2('v1/ApiAdd', data)
}
